import React, { useState, useEffect } from 'react';
import { GoogleMap, Marker, LoadScript } from '@react-google-maps/api';

const ContactMap = () => {

    const [isTrue, setIsTrue] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsTrue(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const mapStyles = {
        height: '400px',
        width: '100%',
    };

    const center = {
        lat: 40.9760200,
        lng: 29.0495634,
    };

    return (
        <LoadScript googleMapsApiKey="AIzaSyCEtcxEqGgvnZnGAGt0jIoORs40lM6OqRU">
            <GoogleMap mapContainerStyle={mapStyles} center={center} zoom={15}>
                {isTrue ? <Marker position={center} /> : null}
            </GoogleMap>
        </LoadScript>
    );
};

export default ContactMap;
